import {
    CREATE_TRANSACTION_PAYMENT,
    CREATE_TRANSACTION_PAYMENT_FAILURE,
    CREATE_TRANSACTION_PAYMENT_SUCCESS,
} from 'store/actions/types';

export const createTransactionPayment = (payload) => {
    return {
        type: CREATE_TRANSACTION_PAYMENT,
        payload: payload,
    };
};

export const createTransactionPaymentFailure = (error) => {
    return {
        type: CREATE_TRANSACTION_PAYMENT_FAILURE,
        error: error,
    };
};

export const createTransactionPaymentSuccess = (response) => {
    return {
        type: CREATE_TRANSACTION_PAYMENT_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/transactions/createTransactions.js